import angular from 'angular';
import chargecodeDetailsComponent from './chargecode-details.component';

let chargecodeDetailsModule = angular.module('chargecodeDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('chargecodeDetails', chargecodeDetailsComponent);

export default chargecodeDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-details/chargecode-details.js